/**
 * Initial state for the editor module.
 *
 * @module store/modules/editor/state
 */
import { EditorState } from "./types";

const state: EditorState = {
  updateContentNode: false,
  uploadSuccess: false,
  isUploadedContentNodes: false,
  oldNodes: {
    content: {},
    trigger: {},
  },
  unsavedContentNodes: {},
  refetchContentNodes: false,
  triggerDiff: {},
  connectedNodes: {
    busy: false,
    data: {},
  },
};

export default state;
